import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class BrowserSessionService {

  private _sessionId: string = null;

  get sessionId(): string {
    return this._sessionId;
  }

  constructor() {
  }

  public generateSession(): void {
    if (!this._sessionId) {
      this._sessionId = uuidv4();
    }
  }
}
